/** FedDev Ontario — Business Scale-up and Productivity (BSP). */
export const FEDDEV_BSP_TASKS = [
  {
    id: 1,
    name: "BSP eligibility",
    completed: false,
    subtasks: [
      { id: "1-1", name: "Confirm Southern Ontario operations and growth stage", completed: false },
      { id: "1-2", name: "Define scale-up project (productivity, market expansion)", completed: false },
    ],
  },
  {
    id: 2,
    name: "Application",
    completed: false,
    subtasks: [
      { id: "2-1", name: "Prepare business plan and financial projections", completed: false },
      { id: "2-2", name: "Submit BSP application with budget", completed: false },
    ],
  },
  {
    id: 3,
    name: "Repayable contribution",
    completed: false,
    subtasks: [
      { id: "3-1", name: "Sign contribution agreement (repayable terms)", completed: false },
      { id: "3-2", name: "Meet reporting and repayment schedule", completed: false },
    ],
  },
];

/** SWODF / EODF — Ontario development funds. */
export const SWODF_EODF_TASKS = [
  {
    id: 1,
    name: "Regional fund selection",
    completed: false,
    subtasks: [
      { id: "1-1", name: "Determine SWODF vs EODF based on location", completed: false },
      { id: "1-2", name: "Confirm eligible capital or growth project", completed: false },
    ],
  },
  {
    id: 2,
    name: "Application package",
    completed: false,
    subtasks: [
      { id: "2-1", name: "Prepare business case and job creation impact", completed: false },
      { id: "2-2", name: "Submit to regional development corporation", completed: false },
    ],
  },
  {
    id: 3,
    name: "Funding compliance",
    completed: false,
    subtasks: [
      { id: "3-1", name: "Execute loan/contribution agreement", completed: false },
      { id: "3-2", name: "File claims and performance reports", completed: false },
    ],
  },
];

/** SOFII — Southern Ontario Fund for Investment in Innovation. */
export const SOFII_TASKS = [
  {
    id: 1,
    name: "Innovation investment case",
    completed: false,
    subtasks: [
      { id: "1-1", name: "Confirm high-growth innovative business in SO region", completed: false },
      { id: "1-2", name: "Align with investor co-investment requirements", completed: false },
    ],
  },
  {
    id: 2,
    name: "Application",
    completed: false,
    subtasks: [
      { id: "2-1", name: "Prepare pitch deck and use-of-funds plan", completed: false },
      { id: "2-2", name: "Submit SOFII application", completed: false },
    ],
  },
  {
    id: 3,
    name: "Closing",
    completed: false,
    subtasks: [
      { id: "3-1", name: "Complete due diligence with FedDev", completed: false },
      { id: "3-2", name: "Execute investment agreement", completed: false },
    ],
  },
];

/** BDC — Business Development Bank financing. */
export const BDC_LOAN_TASKS = [
  {
    id: 1,
    name: "Financing needs",
    completed: false,
    subtasks: [
      { id: "1-1", name: "Define loan purpose (working capital, equipment, growth)", completed: false },
      { id: "1-2", name: "Gather financial statements (2–3 years) and projections", completed: false },
    ],
  },
  {
    id: 2,
    name: "BDC application",
    completed: false,
    subtasks: [
      { id: "2-1", name: "Complete BDC online application or advisor intake", completed: false },
      { id: "2-2", name: "Provide business plan and collateral details", completed: false },
    ],
  },
  {
    id: 3,
    name: "Approval & drawdown",
    completed: false,
    subtasks: [
      { id: "3-1", name: "Review term sheet with client", completed: false },
      { id: "3-2", name: "Sign loan agreement and fund disbursement", completed: false },
    ],
  },
];

/** CSBFP — Canada Small Business Financing Program. */
export const CSBFP_TASKS = [
  {
    id: 1,
    name: "Eligible assets",
    completed: false,
    subtasks: [
      { id: "1-1", name: "Confirm equipment, leaseholds, or commercial vehicle need", completed: false },
      { id: "1-2", name: "Verify borrowing limit and registration fees", completed: false },
    ],
  },
  {
    id: 2,
    name: "Lender application",
    completed: false,
    subtasks: [
      { id: "2-1", name: "Apply through participating financial institution", completed: false },
      { id: "2-2", name: "Submit business plan and asset quotes", completed: false },
    ],
  },
  {
    id: 3,
    name: "Loan closing",
    completed: false,
    subtasks: [
      { id: "3-1", name: "Sign CSBFP loan documents with bank", completed: false },
      { id: "3-2", name: "Purchase eligible assets and confirm registration", completed: false },
    ],
  },
];
